<div class="modal" id="myModal">
    <div class="modal-dialog">
        <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
            <h4 class="modal-title">{{header}}</h4>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
        {{content}}
        </div>

        <!-- Modal footer -->
        <div class="modal-footer">
            <button type="button" (click)=go(true) class="btn btn-primary" data-dismiss="modal">ok</button>
            <button type="button" (click)=go(false) class="btn btn-danger" data-dismiss="modal">Close</button>
        </div>
        </div>
    </div>
</div>

